import * as React from 'react';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import FeedbackIcon from '@material-ui/icons/Feedback';
import { Card, CardContent, CardHeader, FormGroup } from '@material-ui/core';
import { Attachment, Param } from 'src/reducers/completeorderfile';
// import { FormLabel, FormGroup, FormControlLabel, Checkbox, Card, CardContent, CardHeader, GridList, GridListTile, IconButton, Select, InputLabel } from '@material-ui/core';

export interface ViewFeedbackPageViewProps {
    totalRating: number;
    comments: string;
    fbtype: string;
    orderno: string;
    orderdate: string;
    completedon: string;
    tat: string;
    fname: string;
    tool_preferred: string;
    destination: string;
    modelonly: string;
    approval_reqd: string;
    bravopremium: string;
    nounits: string;
    rca: string;
    actionplan: string;
    reviewstatus: string;
    attachments: Attachment[];
    params: Param[];
}

const labels: { [index: string]: string } = {
    1: 'Below Expectations',
    2: 'Average',
    3: 'Good',
    4: 'Very Good',
    5: 'Excellent',
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '100%',
        },
        fontValues: {
            '& .MuiTypography-body1': {
                fontSize: '0.8rem'
            }
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        submit: {
            margin: theme.spacing(1),
            alignItems: 'center'
        },
        rating: {
            // margin: theme.spacing(1),
            width: '100%',
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'start',
            fontSize: '1rem',
        },
        rating_In: {
            // fontSize: '2.2rem',
            color: '#f50057'
        },
        card: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            transition: theme.transitions.create(['all'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        grid_margin: {
            margin: '15px 5px 0px 5px'
        },
        fontCenter: {
            '& .MuiInputBase-input.Mui-disabled': {
                // textAlign: 'center'
                textAlign: 'start'
            }
        },
        gridList: {
            width: 'auto',
            height: 'auto',
        },
        colorHeading: {
            fontSize: '1rem',
            color: 'rgb(3, 129, 237)'
        }
    })
);

const Cards = withStyles({
    root: {
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '8px'
        },
    }
})(Card);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const ViewFeedbackPageView: React.StatelessComponent<ViewFeedbackPageViewProps> = (props) => {
    const classes = useStyles({});
    const attachbycust = props.attachments.filter((file) => file.attachby === 'Customer');
    const attachbyadmin = props.attachments.filter((file) => file.attachby === 'Admin');

    const constructFileUrl = (filename: string) => {
        // Remove any leading slash if present
        const cleanPath = filename.startsWith('/') ? filename.slice(1) : filename;
        return `https://designconnect.mylabconnect.com/easyfiles/${cleanPath}`;
    };
      
    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <div className={classes.paper}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <FeedbackIcon />
                            </Avatar>}
                        title={<Typography component="h1" variant="h5">View Feedback</Typography>}
                    />
                    <div className={classes.form}>
                        <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Order No"
                                            disabled
                                            defaultValue="ORD"
                                            value={props.orderno !== '' ? props.orderno : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Received On"
                                            disabled
                                            defaultValue=""
                                            value={props.orderdate !== '' ? props.orderdate : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Completed On"
                                            disabled
                                            defaultValue=""
                                            value={props.completedon !== '' ? props.completedon : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="TAT"
                                            disabled
                                            defaultValue=""
                                            value={props.tat !== '' ? props.tat : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={6}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="File Name"
                                            disabled
                                            defaultValue=""
                                            value={props.fname !== '' ? props.fname : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Software Used"
                                            disabled
                                            defaultValue=""
                                            value={props.tool_preferred !== '' ? props.tool_preferred : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Destination"
                                            disabled
                                            defaultValue=""
                                            value={props.destination !== '' ? props.destination : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Units Counts​"
                                            disabled
                                            defaultValue=""
                                            value={props.nounits !== '' ? props.nounits : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Model Only​"
                                            disabled
                                            defaultValue=""
                                            value={props.modelonly === 'Y' ? 'Yes' : 'No'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Design Approval​"
                                            disabled
                                            defaultValue=""
                                            value={props.approval_reqd === '1' ? 'Required' : 'No'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Bravo/Premium​"
                                            disabled
                                            defaultValue=""
                                            value={props.bravopremium === '1' ? 'Yes' : 'No'}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Feedback Type​"
                                            disabled
                                            defaultValue=""
                                            value={props.fbtype}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} sm={4} md={4}>
                                        <div className={classes.rating}>
                                            Rating :
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}>
                                        <div className={classes.rating}>
                                            <Rating
                                                size="large"
                                                className={classes.rating_In}
                                                name="hover-feedback"
                                                value={props.totalRating}
                                                precision={1}
                                            />
                                        </div>
                                    </Grid>
                                     <Grid item xs={12} sm={4} md={4}>
                                        <div className={classes.rating}>
                                            {props.totalRating !== null && <Box style={{ justifyContent: 'center' }}>{labels[props.totalRating]}</Box>}
                                        </div>
                                    </Grid> 
                                    {props.totalRating < 5 && (
                                    <Grid item xs={12}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Feedback Type​"
                                            disabled
                                            defaultValue=""
                                            value={props.fbtype}
                                        />
                                    </Grid> 
                                      )}
                                    <Grid item xs={12}>
                                        <CssTextField
                                            fullWidth
                                            label="Comments"
                                            autoFocus
                                            disabled
                                            multiline
                                            rowsMax={4}
                                            value={props.comments}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography>Attachment:</Typography>
                                        <Grid container spacing={1}>
                                            {/* {attachbycust?.map((file) => (
                                                <Grid item key={file.attachfilename} >
                                                    <a 
                                                        href={file.attachfilename}
                                                        // href={`https://designconnect.mylabconnect.com/EasyDent/AxWeb/EasyDentConnectDocs/EasyConnectFiles${file.attachfilename}`}
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                    >
                                                        {file.attachmentname}
                                                    </a>
                                                </Grid>
                                            ))} */}
                                             {attachbycust?.map((file) => (
                                                <Grid item key={file.attachfilename}>
                                                    <a 
                                                        href={constructFileUrl(file.attachfilename)}
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1"
                                                        onClick={(e) => {
                                                            // Optional: Validate URL before opening
                                                            const url = constructFileUrl(file.attachfilename);
                                                            console.log('Accessing URL:', url);
                                                        }}
                                                    >
                                                        {file.attachmentname}
                                                    </a>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {props.params.map((value, index) => (
                                            <Grid item xs={12} key={index}>
                                                <Typography className={classes.colorHeading}>
                                                    {value.title}
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    {value.items.map((item, id) => (
                                                        <Grid item xs={12} md={4} sm={12} key={id}>
                                                            <FormGroup>
                                                                <Typography>{item.data}</Typography>
                                                            </FormGroup>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards>
                        {/* <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            label="Comments"
                                            autoFocus
                                            disabled
                                            multiline
                                            rowsMax={4}
                                            value={props.comments}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards> */}
                        {props.reviewstatus === '1' && 
                        <Cards className={classes.card}>
                            <CardContent >
                                <Typography>Design Center</Typography>
                                <Grid container spacing={2} style={{ padding: '10px 0px 10px 0px' }}>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            label="RCA"
                                            disabled
                                            autoFocus
                                            multiline
                                            rowsMax={4}
                                            value={props.rca}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            label="Action Plan"
                                            disabled
                                            autoFocus
                                            multiline
                                            rowsMax={4}
                                            value={props.actionplan}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography>Attachment:</Typography>
                                        {/* <Grid container spacing={1}>
                                            {attachbyadmin?.map((file) => (
                                                <Grid item key={file.attachfilename} >
                                                    <a 
                                                        href={`https://designconnect.mylabconnect.com/easyfiles${file.attachfilename}`}
                                                        // href={`https://designconnect.mylabconnect.com/easyfiles/05104/20241220/102700245/Feedback/dailyreport27.pdf`}
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                    >
                                                        {file.attachmentname}
                                                    </a>
                                                </Grid>
                                            ))}
                                        </Grid> */}
                                         <Grid container spacing={1}>
                                            {attachbyadmin?.map((file) => (
                                                <Grid item key={file.attachfilename}>
                                                    <a 
                                                        href={constructFileUrl(file.attachfilename)}
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1"
                                                        onClick={(e) => {
                                                            // Optional: Validate URL before opening
                                                            const url = constructFileUrl(file.attachfilename);
                                                            console.log('Accessing URL:', url);
                                                        }}
                                                    >
                                                        {file.attachmentname}
                                                    </a>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards>}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default ViewFeedbackPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/viewFeedbackView.tsx